import kr from '../kr/kr';

export default class RollPresentation extends kr.Component {
    init() {
        this.presentationRoll();
    }
    presentationRoll() {
        const RollDownAngle = document.querySelectorAll('.presentation__angle');
        const PresentationMain = document.querySelectorAll('.presentation');
        
        RollDownAngle.forEach(el=> {
            el.addEventListener('click', ()=> {
                if(el.parentNode.parentNode.classList.contains('presentation--opened')) {
                    el.parentNode.parentNode.classList.remove('presentation--opened');
                }else {
                    el.parentNode.parentNode.classList.add('presentation--opened');
                }
            })
        })
    }
}

kr.registerComponent('.main', {
    component: RollPresentation
});